import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
export class CBcDialogForm {
    constructor(op) {
        this.valid = false;
        this.id = undefined;
        const that = this;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
export class CBcDialog {
    constructor(form) {
        this.negative = {
            isText: true,
            enabled: true,
            visible: true,
            loading: false,
            disableByForm: false,
            text: '取消'
        };
        this.positive = {
            isText: true,
            enabled: true,
            visible: true,
            loading: false,
            disableByForm: false,
            text: '确定'
        };
        this.type = '';
        this.displayTitle = true;
        this.displayText = true;
        this.enableLoading = true;
        this.formValid = false;
        this.visible = false;
        this.loading = false;
        this.loadingText = '';
        this.persistent = undefined;
        this.autoClose = true;
        this.title = '';
        this.text = '';
        this.width = '50%';
        this.transition = '';
        this.form = null;
        const that = this;
        that.form = form;
    }
    get isDeleteType() {
        return this.type === 'delete';
    }
    get isEditType() {
        return this.type === 'edit';
    }
    get isCreateType() {
        return this.type === 'add';
    }
    show(type) {
        if (type)
            this.type = type;
        this.visible = true;
    }
    close() {
        this.visible = false;
    }
    reset() {
        this.width = '50%';
        this.autoClose = false;
        this.negative.visible = true;
        this.positive.visible = true;
        this.persistent = false;
        this.loading = false;
        this.text = '';
        this.title = '';
    }
    accepted() { }
    rejected() { }
}
let BcDialog = class BcDialog extends Vue {
    onShowinChanged(v) {
        if (!v && /function/i.test(typeof this.props.closeAction))
            this.props.closeAction();
        this.$emit('showing', v);
    }
    acceptedHandle() {
        const that = this;
        // this.$emit('okayValue', that.props);
        if (/function/i.test(typeof that.props.acceptedAction))
            that.props.acceptedAction();
        that.$emit('accepted', that.props.form);
        if (that.props.autoClose)
            that.props.close();
    }
    rejectedHandle() {
        const that = this;
        that.$emit('rejected', that.props);
        if (/function/i.test(typeof that.props.rejectedAction))
            that.props.rejectedAction();
        if (that.props.autoClose)
            that.props.close();
    }
};
__decorate([
    Prop()
], BcDialog.prototype, "props", void 0);
__decorate([
    Watch('props.visible')
], BcDialog.prototype, "onShowinChanged", null);
BcDialog = __decorate([
    Component({
        name: 'BcDialog',
    })
], BcDialog);
export default BcDialog;
